<template>
  <div>
    <div class="text-danger" v-if="showNoDataMessage && !isNetworkInfoLoading">
      {{ $t('grid.widgets.alarms.table.no_data') }}
    </div>
    <b-row v-if="networkInfo">
      <div
        class="card col-12 mb-1"
        v-for="(info, index) in networkInfo.NetworkInterfaces"
        :key="index">
        <div
          class="d-flex justify-content-between networkCollapseItem "
          v-b-toggle="'collapse-'+networkInfo.HostName+index">
          <span class="ml-1">{{ info.InterfaceName }}</span>
          <feather-icon
            class="mr-1"
            icon="ChevronDownIcon"
            size="20"
          />
        </div>
        <b-collapse :visible="index === 0" :id="'collapse-'+networkInfo.HostName+index">
          <div class="networkInfoContainer border">
            <div class="d-flex networkInfoItem" v-for="(detail, key) in networkInfo.NetworkInterfaces[index]" :key="key">
              <div class="diskInfoDetailKey">{{ key }}:</div>
              <div class="diskInfoDetailItem">{{ detail }}</div>
            </div>
          </div>
        </b-collapse>
      </div>
    </b-row>
    <b-row v-if="!networkInfo && isNetworkInfoLoading">
      <div class="d-flex flex-column">
        <SkeletonLoading :width="284" :height="37"/>
        <SkeletonLoading :width="284" :height="37"/>
      </div>
    </b-row>
  </div>
</template>

<script>
import { BModal, BSpinner, BCollapse } from "bootstrap-vue";
import { ref, onMounted } from "@vue/composition-api";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import { useNetworkInfo } from "./useNetworkInfo";

export default {
  components: {
    BModal,
    BSpinner,
    SkeletonLoading,
    BCollapse
  },
  props: {
    hanwhaDvr: { type: Object, required: true },
  },
  setup(props, { emit }) {
    onMounted(() => getNetworkInfo());

    const isModalActive = ref(false);
    const { isNetworkInfoLoading, showNoDataMessage , networkInfo, getNetworkInfo } = useNetworkInfo(props.hanwhaDvr)

    return {
      isModalActive,
      isNetworkInfoLoading,
      showNoDataMessage,
      networkInfo
    };
  },
};
</script>

<style lang="scss" scoped>
.networkInfoContainer {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px; /* space between items */
  padding: 16px;
}
.networkInfoItem {
  width: 250px;
}
.networkCollapseItem {
  padding: 5px;
  background-color: rgb(239 239 239) ;
}
.diskInfoDetailKey {
  width: 140px;
  font-weight: 100;
  color: #a5a5a5;
}
.diskInfoDetailItem {
  color: #393735;
}
.dark-layout {
  .diskInfoDetailKey {
    color: #a5a5a5;
  }
  .diskInfoDetailItem {
    color: #fff;
  }
  .networkCollapseItem {
    background-color: #0c0c0c ;
  }
}
</style>
